import { RcFile } from 'antd/es/upload';
import React, { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useField } from '../../field/useField';
import { useFormItemAccessibility } from '../../item/useFormItemAccessibility';
import { UploadInput, UploadInputProps } from './UploadInput';

export interface FileUploadInputProps extends UploadInputProps {
  name: string;
}

export function FileUploadInput({
  name,
  ...uploadProps
}: Readonly<FileUploadInputProps>) {
  const fileField = useField(name);
  const file = useWatch({ name }) as RcFile | null;

  const accessibility = useFormItemAccessibility();
  const methods = useFormContext();

  const fileList = useMemo(() => (file ? [file] : []), [file]);
  const buttonProps = useMemo(
    () => ({
      ...uploadProps.buttonProps,
      disabled: uploadProps.disabled,
    }),
    [uploadProps.disabled, uploadProps.buttonProps],
  );

  return (
    <UploadInput
      {...accessibility.attributes}
      name={name}
      fileList={fileList}
      beforeUpload={file => {
        fileField.setValue(file);
        methods.trigger(name);
        return false;
      }}
      onRemove={() => fileField.setValue(null)}
      {...uploadProps}
      buttonProps={buttonProps}
    />
  );
}
